export default __webpack_public_path__ + "static/media/Guqin Qi 2.d9a1b0ea.png";